export default "__VITE_ASSET__Du5yDUIH__"